import React from "react";
import { Link, withRouter } from "react-router-dom";
import "styles/css/nvabar.scss";
import classNames from "classnames";
import { inject, observer } from "mobx-react";
import {
  ONLINE_WORKSHOPS,
  ONLINE,
  WEBINARS,
  GROUP_SUPERVISION,
  PUBLIC_WEBINARS,
  PUBLIC_WORKSHOPS,
  THERAPY_PROVIDERS,
  INPROGRESS_WORKSHOP,
  COMPLETED_WORKSHOPS,
  REGULAR_WORKSHOPS,
  MY_REGULAR_WORKSHOPS,
  MY_ORGANIZATION_WORKSHOPS,
  PROVIDER_IN_SOLD,
  PROVIDER_MY_WORKSHOP,
  PROVIDER_MY_WEBINARS,
  PROVIDER_MY_GROUP_SUPERVISION,
  POVIDER_MY_PUBLIC_WEBINARS,
  POVIDER_MY_PUBLIC_WORKSHOPS,
  PROVIDER_TRAINEE_RESPONSES,
  PURCHASED,
  MY_CPD_CERT_TEMPLATE,
  PROVIDER_ORG_DETAILS,
} from "stores/WorkshopsUrlConstants";
const APPROVE_WORKSHOP = "approve_workshop";
const APPROVE_MODULE = "approve_module";
const CREATE_ROUTES = ["/createworkshop", "/createregular"];
const ROUTES_WITHOUT_SUB_NAV = [
  '/myprofile/editprofile',
  '/myprofile/editpassword',
  '/create_course_online',
  '/createwebinar',
  '/createworkshop',
  '/createregular',
  '/createpublicwebinar',
  '/createorganization',
  '/our_services',
  '/about-us',
  '/contacts',
  '/termsofconditions',
  '/providerterms',
  '/privacypolicy',
  '/cookiespolicy',
  '/subprocessors',
  '/organisations-info',
  '/provider_bios',
];
@withRouter
@inject("user")
@observer
export default class SubNav extends React.Component {
  state = {
    display: "none",
    activeTab: null,
    activeSubTab: null,
    isProvider: false,
    isAdmin: false
  };

  componentWillMount = () => {
    this.handlePathName(this.props.location);
    this.routerListener = this.props.history.listen((location, action) => {
      this.handlePathName(location);
    });
  };

  getLabel = () => {
    switch(this.state.activeTab) {
      case ONLINE:
        return 'ALL WORKSHOPS';
      case WEBINARS:
        return 'ALL WEBINARS';
      case PUBLIC_WEBINARS:
      case PUBLIC_WORKSHOPS:
      case REGULAR_WORKSHOPS:
        return 'ALL';
      default:
        return '';
    }
  }

  handlePathName = path => {
    const workshop_type = path.search.replace('?workshop_type=', '');
    const isUnpublished = path.search.replace('?workshop_state=', '');
    const scope = path.search.replace('?scope=', '');

    if (path.pathname === "/") this.setState({ display: "none" });
    else if (ROUTES_WITHOUT_SUB_NAV.includes(path.pathname)) this.setState({display: "none"})
    else {
      let activeTab = this.state.activeTab || (workshop_type ? `/${workshop_type}` : '');
      let activeSubTab = this.state.activeSubTab || "";
      if (
        path.pathname.includes(REGULAR_WORKSHOPS) ||
        path.pathname.includes("details/regular")
      ) {
        activeTab = REGULAR_WORKSHOPS;
        activeSubTab = null;
      }
      if (path.pathname.includes(COMPLETED_WORKSHOPS))
        activeSubTab = COMPLETED_WORKSHOPS;
      if (path.pathname.includes(MY_REGULAR_WORKSHOPS))
        activeTab = MY_REGULAR_WORKSHOPS;
      if (path.pathname.includes(MY_ORGANIZATION_WORKSHOPS))
        activeTab = MY_ORGANIZATION_WORKSHOPS;
      if (path.pathname.includes(MY_CPD_CERT_TEMPLATE))
        activeTab = MY_CPD_CERT_TEMPLATE;
      if (path.pathname.includes(INPROGRESS_WORKSHOP))
        activeSubTab = INPROGRESS_WORKSHOP;
      if (path.pathname.includes(PURCHASED)) activeSubTab = PURCHASED;
      if (path.pathname.includes(THERAPY_PROVIDERS))
        activeTab = THERAPY_PROVIDERS;
      if (
        path.pathname.includes(ONLINE_WORKSHOPS) ||
        path.pathname.includes("details/online")
      ) {
        activeTab = ONLINE_WORKSHOPS;
        activeSubTab = null;
      }
      if(path.pathname.includes(ONLINE) ||
        path.pathname.includes("details/online")
      ) {
        activeTab = ONLINE;
        activeSubTab = null;
      }
      if (
        path.pathname.includes(WEBINARS) ||
        path.pathname.includes("details/webinar")
      ) {
        activeTab = WEBINARS;
        activeSubTab = null;
      }
      if (path.pathname.includes(GROUP_SUPERVISION) ||
        path.pathname.includes("details/group_supervision")
      ) {
        activeTab = GROUP_SUPERVISION;
        activeSubTab = null;
      }
      if (path.pathname.includes(PUBLIC_WEBINARS) ||
        path.pathname.includes("details/public_webinars")
      ) {
        activeTab = PUBLIC_WEBINARS;
        activeSubTab = null;
      }
      if (path.pathname.includes(PUBLIC_WORKSHOPS) ||
        path.pathname.includes("details/public_workshops")
      ) {
        activeTab = PUBLIC_WORKSHOPS;
        activeSubTab = null;
      }
      if (path.pathname.includes(REGULAR_WORKSHOPS) ||
        path.pathname.includes("details/regular")
      ) {
        activeTab = REGULAR_WORKSHOPS;
        activeSubTab = null;
      }

      this.setState({ display: "block", activeTab: activeTab, activeSubTab });
    }

    if (
      !path.pathname.includes("provider_bios") &&
      (path.pathname.includes("provider")) &&
      // || CREATE_ROUTES.includes(path.pathname)) &&
      (this.props.user.getUser().role === "coach" ||
        this.props.user.getUser().role === "admin")
    ) {
      let activeTab = "";
      let activeSubTab = this.state.activeSubTab || "";
      if (path.pathname.includes(PROVIDER_IN_SOLD))
        activeTab = PROVIDER_IN_SOLD;
      if (
        path.pathname.includes(PROVIDER_MY_WORKSHOP) ||
        path.pathname.includes("provider/my_workshop")
      ) {
        activeTab = PROVIDER_MY_WORKSHOP;
        activeSubTab = isUnpublished ? isUnpublished : "1";
      }
      if (path.pathname.includes(PROVIDER_MY_WEBINARS) ||
        path.pathname.includes("provider/my_webinar")
      ) {
        activeTab = PROVIDER_MY_WEBINARS;
        activeSubTab = scope ? scope : "upcoming";
        activeSubTab = isUnpublished === '0' ? isUnpublished : activeSubTab;
      }
      if (path.pathname.includes(PROVIDER_MY_GROUP_SUPERVISION) ||
        path.pathname.includes("provider/my_group_supervision")
      ) {
        activeTab = PROVIDER_MY_GROUP_SUPERVISION;
        activeSubTab = scope ? scope : "upcoming";
        activeSubTab = isUnpublished === '0' ? isUnpublished : activeSubTab;
      }
      if (path.pathname.includes(POVIDER_MY_PUBLIC_WEBINARS) ||
        path.pathname.includes("provider/my_public_webinars")
      ) {
        activeTab = POVIDER_MY_PUBLIC_WEBINARS;
        activeSubTab = scope ? scope : "upcoming";
        activeSubTab = isUnpublished === '0' ? isUnpublished : activeSubTab;
      }
      if (path.pathname.includes(POVIDER_MY_PUBLIC_WORKSHOPS) ||
        path.pathname.includes("provider/my_public_workshops")
      ) {
        activeTab = POVIDER_MY_PUBLIC_WORKSHOPS;
        activeSubTab = scope ? scope : "upcoming";
        activeSubTab = isUnpublished === '0' ? isUnpublished : activeSubTab;
      }
      // if (path.pathname.includes(PROVIDER_TRAINEE_RESPONSES))
      //   activeTab = PROVIDER_TRAINEE_RESPONSES;
      if (path.pathname.includes(MY_REGULAR_WORKSHOPS) ||
        path.pathname.includes("provider/regular")
      )
        activeTab = MY_REGULAR_WORKSHOPS;
      if (path.pathname.includes(MY_ORGANIZATION_WORKSHOPS))
        activeTab = MY_ORGANIZATION_WORKSHOPS;
      if (path.pathname.includes(MY_CPD_CERT_TEMPLATE))
        activeTab = MY_CPD_CERT_TEMPLATE;
      if (path.pathname.includes(PROVIDER_ORG_DETAILS))
        activeTab = MY_ORGANIZATION_WORKSHOPS;

      this.setState({
        activeTab: activeTab,
        activeSubTab,
        isProvider: true,
        displayOwn: "block",
      });
    } else {
      this.setState({ isProvider: false, displayOwn: "none" });
    }

    if (
      (path.pathname.includes("adminpanel") ||
        path.pathname.includes("admin")) &&
      this.props.user.getUser().role === "admin"
    ) {
      let activeTab = "";
      activeTab = APPROVE_WORKSHOP;
      this.setState({
        activeTab: activeTab,
        isAdmin: true,
        displayAdmin: "block"
      });
    } else {
      this.setState({ isAdmin: false, displayAdmin: "none" });
    }
  };

  componentWillUnmount = () => {
    this.routerListener();
  };

  isActiveTab = tabName => {
    return this.state.activeTab === tabName;
  };

  isActiveSubTab = subTabName => {
    return this.state.activeTab === subTabName || this.state.activeSubTab === subTabName;
  }

  render() {
    const {isHidden} = this.props;
    const user = this.props.user.getUser();
    return !this.state.isProvider && !this.state.isAdmin ? user.proffession_description === 'General Public' ? (
      <nav
        className="bottom-header row"
        style={{ display: this.state.display }}
      >
        <div className="bottom-header-inner">
          <input
            type="radio"
            name={isHidden ? "" : "tabsGeneral"}
            id="tab3"
            onChange={e => e.preventDefault()}
            checked={this.isActiveTab(PUBLIC_WEBINARS)}
          />
          <Link to={PUBLIC_WEBINARS} className="col bottom-header-content">
            <label htmlFor="tab3">PUBLIC WEBINARS</label>
          </Link>

          <input
            type="radio"
            name={isHidden ? "" : "tabsGeneral"}
            id="tab3"
            onChange={e => e.preventDefault()}
            checked={this.isActiveTab(PUBLIC_WORKSHOPS)}
          />
          <Link to={PUBLIC_WORKSHOPS} className="col bottom-header-content">
            <label htmlFor="tab3">PUBLIC WORKSHOPS</label>
          </Link>

          <div
            className={classNames({
              slide: true,
              "close-tab": this.state.activeTab === ""
            })}
          />
        </div>
          {(this.isActiveTab(PUBLIC_WEBINARS) ||
            this.isActiveTab(PUBLIC_WORKSHOPS) ||
            this.isActiveSubTab(INPROGRESS_WORKSHOP) ||
            this.isActiveSubTab(PURCHASED) ||
            this.isActiveSubTab(COMPLETED_WORKSHOPS)
            ) &&
            <div className='bottom-header-inner' style={{marginTop: '5px'}}>
              <input
                type="radio"
                name={isHidden ? "" : (this.isActiveTab(WEBINARS) ? "subtabs_3" : "subtabs")}
                id="subtab1"
                onChange={e => e.preventDefault()}
                checked={
                  this.isActiveSubTab(PUBLIC_WEBINARS) ||
                  this.isActiveSubTab(PUBLIC_WORKSHOPS)
                }
              />
              <Link to={this.state.activeTab} className="col bottom-header-content">
                <label htmlFor="subtab1">{this.getLabel()}</label>
              </Link>

              <input
                type="radio"
                name={isHidden ? "" : (this.isActiveTab(WEBINARS) ? "subtabs_3" : "subtabs")}
                onChange={e => e.preventDefault()}
                id="subtab2"
                checked={this.isActiveSubTab(PURCHASED)}
              />
              <Link to={`${PURCHASED}?workshop_type=${(this.state.activeTab || '').replace('/', '')}`} className="col bottom-header-content">
                <label htmlFor="subtab2">MY PURCHASES</label>
              </Link>

              {!this.isActiveTab(WEBINARS) && ([
                  <input
                    type="radio"
                    name={isHidden ? "" : "subtabs"}
                    id="subtab4"
                    onChange={e => e.preventDefault()}
                    checked={this.isActiveSubTab(INPROGRESS_WORKSHOP)}
                  />,
                  <Link to={`${INPROGRESS_WORKSHOP}?workshop_type=${(this.state.activeTab || '').replace('/', '')}`} className="col bottom-header-content">
                    <label htmlFor="subtab4">IN PROGRESS</label>
                  </Link>
                ])
              }

              <input
                type="radio"
                name={isHidden ? "" : (this.isActiveTab(WEBINARS) ? "subtabs_3" : "subtabs")}
                id="subtab3"
                onChange={e => e.preventDefault()}
                checked={this.isActiveSubTab(COMPLETED_WORKSHOPS)}
              />
              <Link to={`${COMPLETED_WORKSHOPS}?workshop_type=${(this.state.activeTab || '').replace('/', '')}`} className="col bottom-header-content">
                <label htmlFor="subtab3">COMPLETED</label>
              </Link>
              <div
                className={classNames({
                  sub_slide: true,
                  "close-tab": this.state.activeSubTab === ""
                })}
              />
            </div>
          }
      </nav>
    ) : (
      <nav
        className="bottom-header row"
        style={{ display: this.state.display }}
      >
        <div className="bottom-header-inner">
          <input
            type="radio"
            name={isHidden ? "" : "tabs"}
            id="tab1"
            onChange={e => e.preventDefault()}
            checked={this.isActiveTab(WEBINARS)}
          />
          <Link to={WEBINARS} className="col bottom-header-content">
            <label htmlFor="tab1">Webinars</label>
            <span className="tooltip">for professionals</span>
          </Link>

          <input
            type="radio"
            name={isHidden ? "" : "tabs"}
            id="tab2"
            onChange={e => e.preventDefault()}
            checked={this.isActiveTab(ONLINE)}
          />
          <Link to={ONLINE} className="col bottom-header-content">
            <label htmlFor="tab2">Online Workshops</label>
            <span className="tooltip">On demand for professionals</span>
          </Link>

          <input
            type="radio"
            name={isHidden ? "" : "tabs"}
            id="tab3"
            onChange={e => e.preventDefault()}
            checked={this.isActiveTab(PUBLIC_WEBINARS)}
          />
          <Link to={PUBLIC_WEBINARS} className="col bottom-header-content">
            <label htmlFor="tab3">PUBLIC WEBINARS</label>
            <span className="tooltip">for general public</span>
          </Link>

          <input
            type="radio"
            name={isHidden ? "" : "tabs"}
            id="tab3"
            onChange={e => e.preventDefault()}
            checked={this.isActiveTab(PUBLIC_WORKSHOPS)}
          />
          <Link to={PUBLIC_WORKSHOPS} className="col bottom-header-content">
            <label htmlFor="tab3">PUBLIC WORKSHOPS</label>
            <span className="tooltip">On demand for general public</span>
          </Link>

          <input
            type="radio"
            name={isHidden ? "" : "tabs"}
            id="tab4"
            onChange={e => e.preventDefault()}
            checked={this.isActiveTab(REGULAR_WORKSHOPS)}
          />
          <Link to={REGULAR_WORKSHOPS} className="col bottom-header-content">
            <label htmlFor="tab4">REGULAR Workshops</label>
            <span className="tooltip tooltip-right">In person workshops</span>
          </Link>

          <div
            className={classNames({
              slide: true,
              "close-tab": this.state.activeTab === ""
            })}
          />
        </div>
          {(this.isActiveTab(ONLINE) ||
            this.isActiveTab(WEBINARS) ||
            this.isActiveTab(GROUP_SUPERVISION) ||
            this.isActiveTab(PUBLIC_WEBINARS) ||
            this.isActiveTab(PUBLIC_WORKSHOPS) ||
            this.isActiveTab(REGULAR_WORKSHOPS) ||
            this.isActiveSubTab(INPROGRESS_WORKSHOP) ||
            this.isActiveSubTab(PURCHASED) ||
            this.isActiveSubTab(COMPLETED_WORKSHOPS)
            ) &&
            <div className='bottom-header-inner' style={{marginTop: '5px'}}>
              <input
                type="radio"
                name={isHidden ? "" : (this.isActiveTab(WEBINARS) ? "subtabs_3" : "subtabs")}
                id="subtab1"
                onChange={e => e.preventDefault()}
                checked={
                  this.isActiveSubTab(ONLINE) ||
                  this.isActiveSubTab(WEBINARS) ||
                  this.isActiveSubTab(PUBLIC_WEBINARS) ||
                  this.isActiveSubTab(PUBLIC_WORKSHOPS) ||
                  this.isActiveSubTab(GROUP_SUPERVISION)
                }
              />
              <Link to={this.state.activeTab} className="col bottom-header-content">
                <label htmlFor="subtab1">{this.getLabel()}</label>
              </Link>

              <input
                type="radio"
                name={isHidden ? "" : (this.isActiveTab(WEBINARS) ? "subtabs_3" : "subtabs")}
                onChange={e => e.preventDefault()}
                id="subtab2"
                checked={this.isActiveSubTab(PURCHASED)}
              />
              <Link to={`${PURCHASED}?workshop_type=${(this.state.activeTab || '').replace('/', '')}`} className="col bottom-header-content">
                <label htmlFor="subtab2">MY PURCHASES</label>
              </Link>

              {!this.isActiveTab(WEBINARS) && ([
                  <input
                    type="radio"
                    name={isHidden ? "" : "subtabs"}
                    id="subtab4"
                    onChange={e => e.preventDefault()}
                    checked={this.isActiveSubTab(INPROGRESS_WORKSHOP)}
                  />,
                  <Link to={`${INPROGRESS_WORKSHOP}?workshop_type=${(this.state.activeTab || '').replace('/', '')}`} className="col bottom-header-content">
                    <label htmlFor="subtab4">IN PROGRESS</label>
                  </Link>
                ])
              }

              <input
                type="radio"
                name={isHidden ? "" : (this.isActiveTab(WEBINARS) ? "subtabs_3" : "subtabs")}
                id="subtab3"
                onChange={e => e.preventDefault()}
                checked={this.isActiveSubTab(COMPLETED_WORKSHOPS)}
              />
              <Link to={`${COMPLETED_WORKSHOPS}?workshop_type=${(this.state.activeTab || '').replace('/', '')}`} className="col bottom-header-content">
                <label htmlFor="subtab3">COMPLETED</label>
              </Link>
              <div
                className={classNames({
                  sub_slide: true,
                  "close-tab": this.state.activeSubTab === ""
                })}
              />
            </div>
          }
      </nav>
    ) : this.state.isAdmin ? (
      <nav
        className="bottom-header row smallest"
        style={{ display: this.state.displayAdmin }}
      >
        <div className="bottom-header-inner smallest row">
          <input
            type="radio"
            name={isHidden ? "" : "tabs"}
            id="tab1"
            onChange={e => e.preventDefault()}
            checked={this.isActiveTab(APPROVE_WORKSHOP)}
          />
          <Link
            to={"/adminpanel/" + APPROVE_WORKSHOP}
            className="col bottom-header-content"
          >
            <label htmlFor="tab1">workshop for approval</label>
          </Link>
        </div>
      </nav>
    ) : (
      <nav
        className="bottom-header row small"
        style={{ display: this.state.displayOwn }}
      >
        {this.props.user.getUser().role === "admin" ? (
          <div className="bottom-header-inner small row">
            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab1"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(PROVIDER_MY_WEBINARS)}
            />
            <Link to={PROVIDER_MY_WEBINARS} className="col bottom-header-content">
              <label htmlFor="tab2">MY WEBINARS</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab2"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(PROVIDER_MY_WORKSHOP)}
            />
            <Link to={PROVIDER_MY_WORKSHOP} className="col bottom-header-content">
              <label htmlFor="tab2">MY ONLINE WORKSHOPS</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab3"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(POVIDER_MY_PUBLIC_WEBINARS)}
            />
            <Link to={POVIDER_MY_PUBLIC_WEBINARS} className="col bottom-header-content">
              <label htmlFor="tab2">MY PUBLIC WEBINARS</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab3"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(POVIDER_MY_PUBLIC_WORKSHOPS)}
            />
            <Link to={POVIDER_MY_PUBLIC_WORKSHOPS} className="col bottom-header-content">
              <label htmlFor="tab2">MY PUBLIC WORKSHOPS</label>
            </Link>

            {/* <input
              type="radio"
              name="tabs"
              id="tab1"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(PROVIDER_TRAINEE_RESPONSES)}
            />
            <Link
              to={PROVIDER_TRAINEE_RESPONSES}
              className="col bottom-header-content"
            >
              <label htmlFor="tab1">TRAINEE RESPONSES </label>
            </Link> */}

            {/* <input
              type="radio"
              name="tabs"
              id="tab3"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(PROVIDER_IN_SOLD)}
            />
            <Link to={PROVIDER_IN_SOLD} className="col bottom-header-content">
              <label htmlFor="tab3">MY ONLINE WORKSHOPS SOLD</label>
            </Link> */}

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab4"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(MY_REGULAR_WORKSHOPS)}
            />
            <Link to={MY_REGULAR_WORKSHOPS} className="col bottom-header-content">
              <label htmlFor="tab4">My regular workshops</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab5"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(MY_ORGANIZATION_WORKSHOPS)}
            />
            <Link to={MY_ORGANIZATION_WORKSHOPS} className="col bottom-header-content">
              <label htmlFor="tab5">My organisation workshops</label>
            </Link>
            <div
              className={classNames({
                slide: true,
                "close-tab": this.state.activeTab === ""
              })}
            />
          </div>
        ) : (
          <div className="bottom-header-inner small row">
            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab1"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(PROVIDER_MY_WEBINARS)}
            />
            <Link to={PROVIDER_MY_WEBINARS} className="col bottom-header-content">
              <label htmlFor="tab2">MY WEBINARS</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab2"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(PROVIDER_MY_WORKSHOP)}
            />
            <Link to={PROVIDER_MY_WORKSHOP} className="col bottom-header-content">
              <label htmlFor="tab2">MY ONLINE WORKSHOPS</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab3"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(POVIDER_MY_PUBLIC_WEBINARS)}
            />
            <Link to={POVIDER_MY_PUBLIC_WEBINARS} className="col bottom-header-content">
              <label htmlFor="tab2">MY PUBLIC WEBINARS</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab3"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(POVIDER_MY_PUBLIC_WORKSHOPS)}
            />
            <Link to={POVIDER_MY_PUBLIC_WORKSHOPS} className="col bottom-header-content">
              <label htmlFor="tab2">MY PUBLIC WORKSHOPS</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab4"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(MY_REGULAR_WORKSHOPS)}
            />
            <Link to={MY_REGULAR_WORKSHOPS} className="col bottom-header-content">
              <label htmlFor="tab4">My regular workshops</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "admin_tabs"}
              id="tab5"
              onChange={e => e.preventDefault()}
              checked={this.isActiveTab(MY_CPD_CERT_TEMPLATE)}
            />
            <Link to={MY_CPD_CERT_TEMPLATE} className="col bottom-header-content">
              <label htmlFor="tab5">Cpd cert template</label>
            </Link>

            <div
              className={classNames({
                slide: true,
                "close-tab": this.state.activeTab === ""
              })}
            />
          </div>
        )}

        {(this.isActiveTab(PROVIDER_MY_WORKSHOP) ||
          this.isActiveTab(POVIDER_MY_PUBLIC_WORKSHOPS)
          ) &&
          // <nav
          //   className="bottom-header-inner"
          //   style={{ display: this.state.display, marginBottom: 0 }}
          // >
            <div className='bottom-header-inner' style={{marginTop: '5px'}}>
              <input
                type="radio"
                name={isHidden ? "" : "online_subtabs"}
                id="subtab1"
                onChange={e => e.preventDefault()}
                checked={this.isActiveSubTab('1')}
              />
              <Link to={`${this.state.activeTab}?workshop_state=1`} className="col bottom-header-content">
                <label htmlFor="subtab1">Published</label>
              </Link>

              <input
                type="radio"
                name={isHidden ? "" : "online_subtabs"}
                onChange={e => e.preventDefault()}
                id="subtab2"
                checked={this.isActiveSubTab('0')}
              />
              <Link to={`${this.state.activeTab}?workshop_state=0`} className="col bottom-header-content">
                <label htmlFor="subtab2">Unpublished</label>
              </Link>
              <div
                className={classNames({
                  sub_slide: true,
                  "close-tab": this.state.activeTab === ""
                })}
              />
            </div>
          // </nav>
        }

        {(this.isActiveTab(PROVIDER_MY_WEBINARS) ||
          this.isActiveTab(PROVIDER_MY_GROUP_SUPERVISION)
          ) &&
          <div className='bottom-header-inner' style={{marginTop: '5px'}}>
            <input
              type="radio"
              name={isHidden ? "" : "subtabs"}
              id="subtab1"
              onChange={e => e.preventDefault()}
              checked={this.isActiveSubTab('upcoming')}
            />
            <Link to={`${this.state.activeTab}?scope=upcoming`} className="col bottom-header-content">
              <label htmlFor="subtab1">Upcoming</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "subtabs"}
              onChange={e => e.preventDefault()}
              id="subtab2"
              checked={this.isActiveSubTab('current')}
            />
            <Link to={`${this.state.activeTab}?scope=current`} className="col bottom-header-content">
              <label htmlFor="subtab2">Current</label>
            </Link>
            <input
              type="radio"
              name={isHidden ? "" : "subtabs"}
              id="subtab1"
              onChange={e => e.preventDefault()}
              checked={this.isActiveSubTab('past')}
            />
            <Link to={`${this.state.activeTab}?scope=past`} className="col bottom-header-content">
              <label htmlFor="subtab1">Past</label>
            </Link>

            <input
              type="radio"
              name={isHidden ? "" : "subtabs"}
              onChange={e => e.preventDefault()}
              id="subtab2"
              checked={this.isActiveSubTab('0')}
            />
            <Link to={`${this.state.activeTab}?workshop_state=0`} className="col bottom-header-content">
              <label htmlFor="subtab2">Unpublished</label>
            </Link>
            <div
              className={classNames({
                sub_slide: true,
                "close-tab": this.state.activeTab === ""
              })}
            />
          </div>
        }
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SubNav.jsx